var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import Modal from 'react-bootstrap/lib/Modal';
import Button from '@/shared/components/Button';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
import validateIban from '@/shared/utils/validateIban';
import messages from '../companyMessages';
var BankAccountsModal = function (_a) {
    var show = _a.show, onClose = _a.onClose, companyId = _a.companyId, initialBankAccounts = _a.bankAccounts;
    var intl = useIntl();
    var _b = useState([]), existingAccounts = _b[0], setExistingAccounts = _b[1];
    var _c = useState([]), newAccounts = _c[0], setNewAccounts = _c[1];
    var _d = useState(false), saving = _d[0], setSaving = _d[1];
    var _e = useState(false), showValidation = _e[0], setShowValidation = _e[1];
    var deletedIdsRef = useRef([]);
    var updatedIdsRef = useRef([]);
    var originalRef = useRef([]);
    var resetState = useCallback(function () {
        var copy = initialBankAccounts.map(function (a) { return (__assign({}, a)); });
        setExistingAccounts(copy);
        setNewAccounts([]);
        setSaving(false);
        setShowValidation(false);
        deletedIdsRef.current = [];
        updatedIdsRef.current = [];
        originalRef.current = __spreadArray([], initialBankAccounts, true);
    }, [initialBankAccounts]);
    React.useEffect(function () {
        if (show)
            resetState();
    }, [show, resetState]);
    var fetchBic = function (account, isNew) { return __awaiter(void 0, void 0, void 0, function () {
        var data_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!account.bankAccountNr)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api.base.get('/Api/Bank', {
                            params: { iban: account.bankAccountNr },
                        })];
                case 2:
                    data_1 = (_b.sent()).data;
                    if (!data_1)
                        return [2 /*return*/];
                    if (isNew) {
                        setNewAccounts(function (prev) {
                            return prev.map(function (a) { return (a === account ? __assign(__assign({}, a), { bic: data_1.bic, bankName: data_1.name }) : a); });
                        });
                    }
                    else {
                        setExistingAccounts(function (prev) {
                            return prev.map(function (a) { return (a === account ? __assign(__assign({}, a), { bic: data_1.bic, bankName: data_1.name }) : a); });
                        });
                        markUpdated(account);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var markUpdated = function (account) {
        if (account.id && !updatedIdsRef.current.includes(account.id)) {
            updatedIdsRef.current.push(account.id);
        }
    };
    var handleAddAccount = function () {
        setNewAccounts(function (prev) { return __spreadArray(__spreadArray([], prev, true), [{ bankAccountNr: '', bic: '', bankName: '', isMain: false }], false); });
    };
    var handleDeleteExisting = function (account) {
        if (account.id) {
            deletedIdsRef.current.push(account.id);
            updatedIdsRef.current = updatedIdsRef.current.filter(function (id) { return id !== account.id; });
        }
        setExistingAccounts(function (prev) { return prev.filter(function (a) { return a !== account; }); });
    };
    var handleSetMain = function (account, isNew) {
        if (isNew) {
            setNewAccounts(function (prev) { return prev.map(function (a) { return (__assign(__assign({}, a), { isMain: a === account })); }); });
            setExistingAccounts(function (prev) { return prev.map(function (a) { return (__assign(__assign({}, a), { isMain: false })); }); });
        }
        else {
            setExistingAccounts(function (prev) { return prev.map(function (a) { return (__assign(__assign({}, a), { isMain: a === account })); }); });
            setNewAccounts(function (prev) { return prev.map(function (a) { return (__assign(__assign({}, a), { isMain: false })); }); });
            markUpdated(account);
        }
    };
    var handleExistingChange = function (account, field, value) {
        setExistingAccounts(function (prev) { return prev.map(function (a) {
            var _a;
            return (a === account ? __assign(__assign({}, a), (_a = {}, _a[field] = value, _a)) : a);
        }); });
        markUpdated(account);
    };
    var handleNewChange = function (account, field, value) {
        setNewAccounts(function (prev) { return prev.map(function (a) {
            var _a;
            return (a === account ? __assign(__assign({}, a), (_a = {}, _a[field] = value, _a)) : a);
        }); });
    };
    var isFormValid = function () {
        var allAccounts = __spreadArray(__spreadArray([], existingAccounts, true), newAccounts, true);
        return allAccounts.every(function (a) { return a.bankAccountNr && a.bic && a.bankName && validateIban(a.bankAccountNr); });
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var model, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!newAccounts.length && !deletedIdsRef.current.length && !updatedIdsRef.current.length) {
                        onClose(originalRef.current);
                        return [2 /*return*/];
                    }
                    setSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    model = {
                        companyId: companyId,
                        newBankAccounts: newAccounts,
                        updatedBankAccounts: updatedIdsRef.current.map(function (id) {
                            return existingAccounts.find(function (a) { return a.id === id; });
                        }),
                        deletedBankAccounts: deletedIdsRef.current,
                    };
                    return [4 /*yield*/, api.base.put("/api/company/".concat(companyId, "/bankaccounts"), model)];
                case 2:
                    result = _a.sent();
                    onClose(result.data);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    handleHttpError(intl)(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleCancel = function () {
        onClose(originalRef.current);
    };
    return (_jsxs(Modal, __assign({ show: show, onHide: handleCancel, bsSize: "lg", backdrop: "static", enforceFocus: false }, { children: [_jsx(Modal.Header, __assign({ closeButton: true }, { children: _jsx(Modal.Title, { children: intl.formatMessage(messages.ModifyBankAccounts) }) })), _jsx(Modal.Body, { children: _jsxs("table", __assign({ style: { width: '100%', borderCollapse: 'separate', borderSpacing: '0 8px' } }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", __assign({ style: { width: '2%' } }, { children: _jsx("span", __assign({ className: "clickable", title: intl.formatMessage(messages.MainBankAccountTooltip) }, { children: _jsx("i", { className: "fa fa-info-circle fa-fw" }) })) })), _jsx("th", __assign({ className: "col-md-2", style: { paddingLeft: 0 } }, { children: intl.formatMessage(messages.BankAccountNr) })), _jsx("th", __assign({ className: "col-md-2", style: { paddingLeft: 0 } }, { children: intl.formatMessage(messages.BIC) })), _jsx("th", __assign({ className: "col-md-3", style: { paddingLeft: 0 } }, { children: intl.formatMessage(messages.Bank) })), _jsx("th", { className: "col-md-1" })] }) }), _jsxs("tbody", { children: [existingAccounts.map(function (account, index) { return (_jsxs("tr", { children: [_jsx("td", { children: _jsx("a", __assign({ className: "btn btn-sm btn-icon", onClick: function () { return !account.isMain && handleSetMain(account, false); } }, { children: _jsx("i", { className: "text-orange ".concat(account.isMain ? 'fa fa-star' : 'fa fa-star-o clickable') }) })) }), _jsx("td", { children: _jsx("input", { className: "form-control input-xx".concat(showValidation &&
                                                    (!account.bankAccountNr || !validateIban(account.bankAccountNr))
                                                    ? ' markedError'
                                                    : ''), type: "text", value: account.bankAccountNr, onChange: function (e) { return handleExistingChange(account, 'bankAccountNr', e.target.value); }, onBlur: function () { return fetchBic(account, false); }, placeholder: intl.formatMessage(messages.BankAccountNr), autoComplete: "off" }) }), _jsx("td", { children: _jsx("input", { className: "form-control input-xx".concat(showValidation && !account.bic ? ' markedError' : ''), type: "text", value: account.bic, onChange: function (e) { return handleExistingChange(account, 'bic', e.target.value); }, placeholder: intl.formatMessage(messages.BIC), autoComplete: "off" }) }), _jsx("td", { children: _jsx("input", { className: "form-control input-xx".concat(showValidation && !account.bankName ? ' markedError' : ''), type: "text", value: account.bankName, onChange: function (e) { return handleExistingChange(account, 'bankName', e.target.value); }, placeholder: intl.formatMessage(messages.Bank), autoComplete: "off" }) }), _jsx("td", __assign({ className: "text-right" }, { children: _jsx("a", __assign({ className: "btn btn-sm btn-icon", onClick: function () { return handleDeleteExisting(account); }, title: intl.formatMessage(messages.Remove) }, { children: _jsx("i", { className: "fa fa-trash-o" }) })) }))] }, account.id || "existing-".concat(index))); }), newAccounts.map(function (account, index) { return (_jsxs("tr", { children: [_jsx("td", { children: _jsx("a", __assign({ onClick: function () { return !account.isMain && handleSetMain(account, true); } }, { children: _jsx("i", { className: account.isMain ? 'fa fa-star text-orange' : 'fa fa-star-o clickable' }) })) }), _jsx("td", { children: _jsx("input", { className: "form-control input-xx".concat(showValidation &&
                                                    (!account.bankAccountNr || !validateIban(account.bankAccountNr))
                                                    ? ' markedError'
                                                    : ''), type: "text", value: account.bankAccountNr, onChange: function (e) { return handleNewChange(account, 'bankAccountNr', e.target.value); }, onBlur: function () { return fetchBic(account, true); }, placeholder: intl.formatMessage(messages.BankAccountNr), autoComplete: "off" }) }), _jsx("td", { children: _jsx("input", { className: "form-control input-xx", type: "text", value: account.bic, onChange: function (e) { return handleNewChange(account, 'bic', e.target.value); }, placeholder: intl.formatMessage(messages.BIC), autoComplete: "off" }) }), _jsx("td", { children: _jsx("input", { className: "form-control input-xx", type: "text", value: account.bankName, onChange: function (e) { return handleNewChange(account, 'bankName', e.target.value); }, placeholder: intl.formatMessage(messages.Bank), autoComplete: "off" }) }), _jsx("td", {})] }, "new-".concat(index))); })] })] })) }), _jsxs(Modal.Footer, { children: [_jsxs("button", __assign({ className: "btn btn-inverse pull-left", onClick: handleAddAccount }, { children: [_jsx("i", { className: "fa fa-plus" }), _jsx("span", __assign({ className: "margin5L" }, { children: intl.formatMessage(messages.AddBankAccount) }))] })), _jsx(Button, __assign({ onClick: handleCancel, name: "BankAccounts-Close" }, { children: intl.formatMessage(messages.Close) })), _jsxs("button", __assign({ className: "btn btn-inverse", onClick: handleSave, onMouseOver: function () { return setShowValidation(true); }, disabled: saving || (showValidation && !isFormValid()) }, { children: [saving && _jsx("i", { className: "fa fa-spinner fa-spin margin5R" }), _jsx("span", { children: intl.formatMessage(messages.Save) })] }))] })] })));
};
export default BankAccountsModal;
